import React from "react"
import {findDOMNode} from "react-dom"

import Popover from "../../../../../gd-components/gd-popover/popover-v2"
import PopoverPosition from "../../../../../gd-components/gd-popover/popover-position"
import {PopoverAttachmentType} from "../../../../../gd-components/gd-popover/@const"

import FieldRAG_Icon from "../rag-icon"

const popoverPosition = new PopoverPosition({
    attachment      : "top center",
    targetAttachment: "bottom center",
    attachmentType  : PopoverAttachmentType.FULL,
})

export default function FieldRAG_Popover(props:any) {
    return (
        <Popover className        = "fl-ac p-t-10 p-r-10 p-b-10 p-l-10"
                 position           = {popoverPosition}
                 getTargetFunc      = {()=>findDOMNode(props.parent)}
                 onClickOutside     = {()=>{props.parent.hidePopover()}}>
            {_.map(props.field.options, (option, key)=>{
                if (option.excludeFromSelectable) return null

                return (
                    <FieldRAG_Icon key          = {key}
                                   className    = "m-r-4 m-l-4 lh-20"
                                   option       = {option}
                                   onClick      = {option=>props.parent.onOptionClick(option)}/>
                )
            })}
        </Popover>
    )
}